import { EmployeeGuard } from '@employees/guards/employee.guard';

const Guards = [EmployeeGuard];

export { Guards, EmployeeGuard };
